module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_pp12_8004.7775131d.png";